import { Loading } from 'element-ui'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
// 格式化日对象
const getNowDate = () => {
  var date = new Date()
  var sign2 = ':'
  var year = date.getFullYear() // 年
  var month = date.getMonth() + 1 // 月
  var day = date.getDate() // 日
  var hour = date.getHours() // 时
  var minutes = date.getMinutes() // 分
  var seconds = date.getSeconds() //秒
  // 给一位数的数据前面加 “0”
  if (month >= 1 && month <= 9) {
    month = '0' + month
  }
  if (day >= 0 && day <= 9) {
    day = '0' + day
  }
  if (hour >= 0 && hour <= 9) {
    hour = '0' + hour
  }
  if (minutes >= 0 && minutes <= 9) {
    minutes = '0' + minutes
  }
  if (seconds >= 0 && seconds <= 9) {
    seconds = '0' + seconds
  }
  return (
    year +
    '-' +
    month +
    '-' +
    day +
    ' ' +
    hour +
    sign2 +
    minutes +
    sign2 +
    seconds
  )
}

// 文件下载

// 图片url字符串处理
// const imgUrlStr = function(url){
//     if(url){
//         let newUrl = url.substr(-10)
//     }
// }

// 文件下载
const download = function (url, name = '', suffix = '', open = 'post') {
  let loadingInstance = Loading.service({
    fullscreen: true,
    lock: true,
    text: '下载中...',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)',
  })
  let token = localStorage.getItem('jwtToken')
  function createObjectURL(object) {
    return window.URL
      ? window.URL.createObjectURL(object)
      : window.webkitURL.createObjectURL(object)
  }
  const xhr = new XMLHttpRequest()
  const formData = new FormData()
  xhr.open(open, url) //url填写后台的接口地址，如果是post，在formData append参数（参考原文地址）
  xhr.setRequestHeader('Authorization', 'Bearer ' + token)
  xhr.responseType = 'blob'
  xhr.onload = function (e) {
    console.log(e, 'eeeee')
    if (this.status == 200) {
      setTimeout(() => {
        loadingInstance.close()
      })
      if (this.response.type == 'application/json') {
        return alert('下载失败，请稍后再试')
      }
      const blob = this.response
      let filename = name //这里的名字，可以按后端给的接口固定表单设置一下名字，如（费用单.xlsx,合同.doc等等）
      if (suffix && suffix.length > 1) {
        filename = filename.concat(suffix)
      }
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, filename)
      } else {
        var a = document.createElement('a')
        var url = createObjectURL(blob)
        a.href = url
        a.download = filename
        document.body.appendChild(a)
        a.click()
        window.URL.revokeObjectURL(url)
      }
    }
  }
  xhr.send(formData)
}

// 数组去重
const arrayDeduplication = function (arr) {
  var newarr = []
  for (var i = 0; i < arr.length; i++) {
    if (newarr.lastIndexOf(arr[i]) === -1) {
      newarr.push(arr[i])
    }
  }
  return newarr
}
// 金额格式化
const momenyFormat = function (num) {
  num = Number(num)
  if (isNaN(num)) return '0.00'
  return num.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
}
// 上传图片压缩
// 图片压缩
/**
 * imgSrc 地址
 * scale 压缩质量 0-1
 * type 文件类型
 */
const compressImg = function (imgSrc, scale, type, callback) {
  // uni.$u.toast('压缩中')
  var img = new Image()
  img.src = imgSrc
  img.onload = function () {
    var that = this
    var h = (img.height * scale).toFixed(0) // 默认按质量比例压缩
    var w = (img.width * scale).toFixed(0)
    var canvas = document.createElement('canvas')
    var ctx = canvas.getContext('2d')
    var width = document.createAttribute('width')
    width.nodeValue = w
    var height = document.createAttribute('height')
    height.nodeValue = h
    canvas.setAttributeNode(width)
    canvas.setAttributeNode(height)
    ctx.drawImage(that, 0, 0, w, h)
    var base64 = canvas.toDataURL('image/jpeg', scale) //压缩比例
    canvas = null
    if (type == 'base64') {
      // eslint-disable-next-line no-unused-vars
      let data = {
        size: getBase64Size(base64),
        type: type,
        source: base64,
      }
      callback(base64)
    } else {
      let blob = base64ToBlob(base64)
      // console.log('压缩后的大小', blob, blob.size, blob.type)
      const blobUrl = window.URL.createObjectURL(blob) //blob地址
      blob.source = blobUrl
      callback(blob)
    }
  }
}

// base转Blob
const base64ToBlob = function (base64) {
  var arr = base64.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new Blob([u8arr], {
    type: mime,
  })
}
// 获取base64的文件大小
const getBase64Size = function (base64Str) {
  let size = 0
  if (base64Str) {
    // 获取base64图片byte大小
    const equalIndex = base64Str.indexOf('=') // 获取=号下标
    if (equalIndex > 0) {
      const str = base64Str.substring(0, equalIndex) // 去除=号
      const strLength = str.length
      const fileLength = strLength - (strLength / 8) * 2 // 真实的图片byte大小
      size = Math.floor(fileLength) // 向下取整
    } else {
      const strLength = base64Str.length
      const fileLength = strLength - (strLength / 8) * 2
      size = Math.floor(fileLength) // 向下取整
    }
  } else {
    size = null
  }
  return size
}

// 格式化成年月日
// 使用方式
// var year = getDateTime('year');
// console.log(year);  // 2021
// var month = getDateTime('month');
// console.log(month); // 2021-12
// var date = getDateTime('');
// console.log(date);  // 2021-12-03 09:00:00
// 日期格式化年月日函数
const formatDate = function (type, format) {
  var date = new Date()
  var hengGang = '-'
  var maoHao = ':'
  var year = date.getFullYear()
  var month = date.getMonth() + 1
  var curDate = date.getDate()
  var curHours = date.getHours()
  var curMinutes = date.getMinutes()
  var curSeconds = date.getSeconds()
  if (month >= 1 && month <= 9) {
    month = '0' + month
  }
  if (curDate >= 0 && curDate <= 9) {
    curDate = '0' + curDate
  }
  if (curHours >= 0 && curHours <= 9) {
    curHours = '0' + curHours
  }
  if (curMinutes >= 0 && curMinutes <= 9) {
    curMinutes = '0' + curMinutes
  }
  if (curSeconds >= 0 && curSeconds <= 9) {
    curSeconds = '0' + curSeconds
  }
  var currentdate = ''
  if (type == 'format') {
    // 传递需要的日期 格式化成年月日 只要年月日  format是传递的日期参数
    currentdate = format.slice(0, 10)
    return currentdate
  } else if (type == 'year') {
    // 获取年份
    currentdate = year
    return currentdate
  } else if (type == 'month') {
    // 获取年份月份
    currentdate = year + hengGang + month
    return currentdate
  } else if (type == 'day') {
    // 获取年月日
    currentdate = year + hengGang + month + hengGang + curDate
    return currentdate
  } else if (type == 'minutes') {
    // 获取年月日 时分
    currentdate =
      year +
      hengGang +
      month +
      hengGang +
      curDate +
      ' ' +
      curHours +
      maoHao +
      curMinutes
  } else {
    // 获取年月日 + 当前时间
    currentdate =
      year +
      hengGang +
      month +
      hengGang +
      curDate +
      ' ' +
      curHours +
      maoHao +
      curMinutes +
      maoHao +
      curSeconds
    return currentdate
  }
}

// 获取指定日期以前的时间点
const friendlyDate = function (timestamp) {
  var formats = {
    year: '%n% 年前',
    month: '%n% 月前',
    day: '%n% 天前',
    hour: '%n% 小时前',
    minute: '%n% 分钟前',
    second: '%n% 秒前',
  }

  var now = Date.now()
  var seconds = Math.floor((now - timestamp) / 1000)
  var minutes = Math.floor(seconds / 60)
  var hours = Math.floor(minutes / 60)
  var days = Math.floor(hours / 24)
  var months = Math.floor(days / 30)
  var years = Math.floor(months / 12)

  var diffType = ''
  var diffValue = 0
  if (years > 0) {
    diffType = 'year'
    diffValue = years
  } else {
    if (months > 0) {
      diffType = 'month'
      diffValue = months
    } else {
      if (days > 0) {
        diffType = 'day'
        diffValue = days
      } else {
        if (hours > 0) {
          diffType = 'hour'
          diffValue = hours
        } else {
          if (minutes > 0) {
            diffType = 'minute'
            diffValue = minutes
          } else {
            diffType = 'second'
            diffValue = seconds === 0 ? (seconds = 1) : seconds
          }
        }
      }
    }
  }
  return formats[diffType].replace('%n%', diffValue)
}
// 千分位格式化
// eslint-disable-next-line no-unused-vars
const toThousands = function (value) {
  if (!value) return '0.00'

  var intPart = Number(value) | 0 //获取整数部分

  let splitNums = parseFloat(value).toFixed(2).split('.')

  var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') //将整数部分每三位加一个逗号

  var floatPart = '.00' //预定义小数部分

  if (typeof value !== 'string') {
    value = value.toString()
  }

  if (value == 0) {
    value = 0.0
  }

  if (value) {
    var value2Array = value.split('.')
    //=2表示数据有小数位

    if (value2Array.length == 2) {
      floatPart = value2Array[1].toString() //拿到小数部分

      if (floatPart.length > 2) {
        //若小数位数在两位以上，则四舍五入保留两位小数

        return intPartFormat + '.' + splitNums[1]
      } else if (floatPart.length == 1) {
        //若小数位数只有一位，补0

        return intPartFormat + '.' + floatPart + '0'
      } else {
        return intPartFormat + '.' + floatPart
      }
    } else {
      //数据为整数

      return intPartFormat + floatPart
    }
  }
}

// 导出PDF功能
/**
 * 导出页面为PDF
 * @param {String} elementSelector - 要导出的DOM元素选择器
 * @param {String} filename - 导出的文件名
 * @param {Object} options - 配置选项
 * @param {Number} options.scale - 缩放比例，默认0.8
 * @param {Number} options.padding - PDF内边距（mm），默认15
 */
const exportToPDF = async function (
  elementSelector,
  filename = '导出文档',
  options = {}
) {
  try {
    const element = document.querySelector(elementSelector)
    if (!element) {
      throw new Error('未找到指定的DOM元素')
    }

    // 显示 loading
    const loadingInstance = Loading.service({
      fullscreen: true,
      lock: true,
      text: '正在导出PDF...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)',
    })

    // 确保元素可见且有尺寸
    element.style.display = 'block'

    // 提取配置参数
    const { scale = 1, ...otherOptions } = options

    // 默认配置
    const defaultOptions = {
      scale: scale,
      useCORS: true,
      allowTaint: true,
      backgroundColor: '#ffffff',
      ...otherOptions,
    }

    try {
      // 等待一小段时间确保DOM渲染完成
      await new Promise((resolve) => setTimeout(resolve, 500))

      // 使用html2canvas截图整个元素
      const canvas = await html2canvas(element, defaultOptions)
      const imgData = canvas.toDataURL('image/jpeg', 1.0)

      // 检查canvas是否为空
      if (canvas.width === 0 || canvas.height === 0) {
        throw new Error('Canvas尺寸为0，请检查元素是否正确渲染')
      }

      // 创建PDF
      const pdf = new jsPDF('p', 'mm', 'a4')
      const pageWidth = pdf.internal.pageSize.getWidth()
      const pageHeight = pdf.internal.pageSize.getHeight()

      // 计算图片在PDF中的尺寸
      const imgWidth = pageWidth
      const imgHeight = (canvas.height * pageWidth) / canvas.width

      // 如果图片高度超过页面高度，则调整页面尺寸
      if (imgHeight > pageHeight) {
        // 创建自定义尺寸的PDF页面
        pdf.addPage([imgWidth, imgHeight])
        pdf.deletePage(1) // 删除默认的第一页
        pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth, imgHeight)
      } else {
        // 图片高度未超过页面高度，直接添加到PDF
        pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth, imgHeight)
      }

      // 保存PDF
      pdf.save(`${filename}.pdf`)

      return {
        success: true,
        message: 'PDF导出成功',
        info: {
          scale: scale,
          fileSize: '已优化',
        },
      }
    } finally {
      // 关闭 loading
      loadingInstance.close()
    }
  } catch (error) {
    console.error('PDF导出失败:', error)
    // 关闭 loading
    const loadingInstance = Loading.service({
      fullscreen: true,
      lock: true,
      text: '下载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)',
    })
    setTimeout(() => {
      loadingInstance.close()
    }, 100)

    return {
      success: false,
      message: `PDF导出失败: ${error.message}`,
    }
  }
}

export default {
  // 日期格式化
  getNowDate,
  // 日期格式化
  formatDate,
  // 获取指定日期以前的时间点
  friendlyDate,
  // 文件下载
  download,
  // 数组去重
  arrayDeduplication,
  // 金额格式化
  momenyFormat,
  // 上传图片压缩
  compressImg,
  // 导出PDF
  exportToPDF,
}
